import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {SwapperComponent} from '../../../assets/ts/components'
import {ROUTES} from '../../../constants/_routes'
import {ChecklistButton} from './ChecklistButton'
import {AccountButton} from './AccountButton'
import {SettingButton} from './SettingButton'
import {WalletButton} from './WalletButton'

const Topbar = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return (
    <div className='d-flex align-items-center flex-shrink-0 w-sm-auto'>
      {currentUser && (
        <>
          <div className='wallet-button wallet-button--topbar'>
            <WalletButton />
          </div>
          <div className='d-block'>
            <ChecklistButton />
          </div>
          <div className='d-block'>
            <SettingButton />
          </div>
          <div className='d-block'>
            <AccountButton />
          </div>
        </>
      )}

      {!currentUser && (
        <Link
          to={ROUTES.AUTH.LOGIN}
          onClick={() => SwapperComponent.removeInstances()}
          className='d-flex flex-stack'
        >
          <button type='button' className='btn btn-advanced-secondary rounded-pill px-5 px-md-8'>
            {intl.formatMessage({id: 'LOG_IN'})}
          </button>
        </Link>
      )}
    </div>
  )
}

export {Topbar}
